<template>
  <ul class="form-item-list">
    <li>
      <h3>청약서 수령처 정보를 입력해주세요</h3>
    </li>
    <li>
      <element-textbox
        v-model="formData.이메일주소.value"
        :label="formData.이메일주소.label"
        :error="formData.이메일주소.error"
        :placeholder="formData.이메일주소.placeholder"
      />
      <h5 style="color: #787878; margin-top: 5px;">청약서 받을 이메일 주소​를 입력하십시오.</h5>
    </li>
    <li>
      <el-row>
        <div class="label">우편주소</div>
        <el-col :span="12" @click.native="postcodeOpen">
          <el-input
            type="text"
            v-model="address"
            :placeholder="formData.우편주소.placeholder"
            @input="changeAddress"
          />
        </el-col>
        <el-col :span="12">
          <el-input
            type="text"
            v-model="address_sub"
            placeholder="우편주소2"
            @input="changeAddress"
          />
        </el-col>
      </el-row>
      <h5 style="color: #787878; margin-top: 5px;">보험증권 받으실 우편 주소를 입력하십시오.​​​</h5>
    </li>
    <li>
      <element-textarea
        v-model="formData.남길말씀.value"
        :error="formData.남길말씀.error"
        :label="formData.남길말씀.label"
        :placeholder="formData.남길말씀.placeholder"
      />
      <h5 style="color: #787878; margin-top: 5px;">청약 전에 담당자가 검토 후 진행 할 내용이 있으면 알려주십시오.​​​</h5>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'Address',
  props: ['formData'],
  data() {
    return {
      address: '',
      address_sub: '',
    }
  },
  watch: {
    'formData.이메일주소.value': function (email) {
      const regExp = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      
      this.formData.이메일주소.error = '';

      if (!regExp.test(email)) {
        this.formData.이메일주소.error = '이메일 주소 형식이 올바르지 않습니다.';
        return;
      }

      this.update('이메일주소', email);
    },
    'formData.남길말씀.value': function (comment) {
      this.update('남길말씀', comment);
    },
  },
  mounted() {
    if (this.formData.우편주소.value) {
      const address = this.formData.우편주소.value.split('|');

      this.address = address[0];

      if (address[1]) {
        this.address_sub = address[1];
      }
    }
  },
  methods: {
    postcodeOpen() {
      console.log('aaa')
      const _this = this;
      new daum.Postcode({
        oncomplete: function(data) {
          _this.address = data.address
        }
      }).open();
    },
    update(type, value) {
      if (value !== '') {
        this.$emit('update', { type, value });
      }
    },
    changeAddress() {
      const address = `${this.address} ${this.address_sub}`;
      this.$emit('update', { type: '우편주소', value: address });
    }
  }
}
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 2*$unit;

  &.my-1 {
    margin-bottom: $unit;
  }
  .mx-0 {
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: $unit;
  }
  .el-input {
    height: 54px;

    /deep/ .el-input__inner {
      height: 54px;
      border-radius: 0;
      color: #000;
    }

    ::placeholder {
      text-align: left;
    }
  }
}
</style>